window.FormSubmit = (function(window,jQuery){
	var FormSubmit = {
						'elm': false,
						'responseData': false,
						'submitData': false,
						'loader': $('<div>').addClass('svg-loader'),
						'successMessage': $('<div>').addClass('loading').append($('<h1>').text('Message Sent!')).append($('<span>').addClass('sperator')).append($('<p>').text('Thank you. Your enquiry has been successfully sent. We will contact you shortly.'))
					};

	FormSubmit.submit = function(elm){
		FormSubmit.elm = $(elm);
		FormSubmit.elm.find('.errormessage').remove();
		FormSubmit.submitData = FormSubmit.elm.serialize() + '&ajax=true';
		FormSubmit.showLoader();
		FormSubmit.makeRequest();
	}

	FormSubmit.showLoader = function(){
		if(FormSubmit.elm != false){
			FormSubmit.loader.insertAfter(FormSubmit.elm.find('.loading'));
		}
	}

	FormSubmit.hideLoader = function(){
		FormSubmit.loader.remove();
	}

	FormSubmit.makeRequest = function(){
		if(FormSubmit.submitData != false){
			$.ajax({
	            url: $(location).attr('href'),
				data: FormSubmit.submitData,
	            method: "POST",
	            dataType: "json"
	        }).success(function (data) {
	           FormSubmit.responseData = data;
	           FormSubmit.handleData();
	        }).fail(function () {
	        	FormSubmit.errorHandler('Something went wrong while sending your information, please try again.');
	        });
	        FormSubmit.submitData = false;
		}
	}

	FormSubmit.handleData = function(){
		FormSubmit.hideLoader();
		if(FormSubmit.responseData != false){
			if(FormSubmit.responseData.success == false){
				FormSubmit.errorHandler();
			} else {
				FormSubmit.successHandler();
			}
		}
	}

	FormSubmit.errorHandler = function(message){
		if(message){
			FormSubmit.elm.find('.loading').append($('<p>').addClass('errormessage').html(message));
		} else if(FormSubmit.responseData.success == false){
			for (var key in FormSubmit.responseData.error) {
				FormSubmit.elm.find('input[name="' + key + '"]').parents('.formrow').addClass('error').find('label .message').text(FormSubmit.responseData.error[key]);
			}
		}
		FormSubmit.clean();
	}

	FormSubmit.successHandler = function(){
		if(FormSubmit.responseData.success != false){
			FormSubmit.elm.html(FormSubmit.successMessage);
		}
		FormSubmit.clean();
	}

	FormSubmit.clean = function(){
		FormSubmit.elm = false;
		FormSubmit.responseData = false;
		FormSubmit.submitData = false;
	}

	return FormSubmit;
})(window,jQuery);